export function isInternal(email) {
  return !!email?.toLowerCase().endsWith("@hpe.com")
}
